import Vue from 'vue'

const ErrorDefault = Vue.component('error-default', {
    props: ['message'],
    template: '#error_default'
})

export default ErrorDefault;
